import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useFetch } from "@/hooks/useFetch";
import { api } from "@/lib/api";

export const NotificationsBell = () => {
  const { data, reload } = useFetch("/notifications");
  const unread = data?.unread || 0;

  const markAll = async () => {
    await api.post("/notifications/read-all");
    reload();
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="relative inline-flex h-9 w-9 items-center justify-center rounded-lg border bg-card transition-colors hover:bg-muted" data-testid="notifications-bell-btn" aria-label="Notificações">
          <Bell className="h-4 w-4" />
          {unread > 0 && (
            <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold text-white" data-testid="notifications-unread-count">
              {unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" data-testid="notifications-panel">
        <div className="flex items-center justify-between border-b px-4 py-3">
          <span className="font-heading font-semibold">Lembretes</span>
          {unread > 0 && (
            <button onClick={markAll} className="text-xs font-medium text-primary hover:underline" data-testid="notifications-read-all-btn">
              Marcar como lidas
            </button>
          )}
        </div>
        <div className="max-h-80 overflow-y-auto">
          {!data?.enabled ? (
            <p className="p-4 text-sm text-muted-foreground">Lembretes automáticos estão disponíveis no plano Profissional.</p>
          ) : data.items.length === 0 ? (
            <p className="p-4 text-sm text-muted-foreground">Nenhum lembrete no momento.</p>
          ) : (
            data.items.map((n) => (
              <div key={n.id} className={`border-b px-4 py-3 text-sm last:border-0 ${n.read ? "text-muted-foreground" : ""}`} data-testid={`notification-${n.id}`}>
                {!n.read && <span className="mr-2 inline-block h-2 w-2 rounded-full bg-primary" />}
                {n.message}
              </div>
            ))
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
